import dayjs from 'dayjs';
import { get, orderBy } from 'lodash-es';
import { createSelector } from 'reselect';
import { CARE_ORDER_BABY_TYPE, } from '@/interface/domain/careOrderBaby';
import { getPartTimeTimeSlotOptionList } from '../../../util/helper/option';
import { CARE_ORDER_PLAN_KEY } from '../../../config/careOrderPlan';
const initialType = {
    requiredGender: null,
    symptom: [],
    tube: [],
    servedItem: [],
    hospitalBed: null,
    lang: null,
    notes: '',
    isAsap: null,
    initialType: CARE_ORDER_BABY_TYPE.ALL_DAY,
    timeSlotList: [],
    careOrderPlanKey: CARE_ORDER_PLAN_KEY.ALL_DAY,
    partTimeExpectedStartTime: '',
    partTimeExpectedServiceHours: null,
    hospitalObj: null,
    gender: null,
    height: null,
    weight: null,
    age: null,
    contactName: null,
    contactGender: null,
    contactPhone: null,
    contactEmail: null,
    extraNoteList: [],
};
var ACTION_TYPES;
(function (ACTION_TYPES) {
    ACTION_TYPES["CARE_ORDER_BABY_FORM_INIT"] = "careOrderBabyForm/init";
    ACTION_TYPES["CARE_ORDER_BABY_FORM_UPDATE"] = "careOrderBabyForm/update";
    ACTION_TYPES["CARE_ORDER_BABY_FORM_UPDATE_ALL_DAY_TIME_SLOT"] = "careOrderBabyForm/updateAllDayTimeSlot";
    ACTION_TYPES["CARE_ORDER_BABY_FORM_APPLY_NEW_PART_TIME_EXPECTED_SERVICE_HOURS"] = "careOrderBabyForm/applyNewPartTimeExpectedServiceHours";
    ACTION_TYPES["CARE_ORDER_BABY_FORM_APPLY_NEW_PART_TIME_EXPECTED_START_TIME"] = "careOrderBabyForm/applyNewPartTimeExpectedStartTime";
    ACTION_TYPES["CARE_ORDER_BABY_FORM_UPDATE_PART_TIME_TIME_SLOT_LIST"] = "careOrderBabyForm/updatePartTimeTimeSlotList";
    ACTION_TYPES["CARE_ORDER_BABY_FORM_RESET_TIME_SELECTION_DATA"] = "careOrderBabyForm/resetTimeSelectionData";
})(ACTION_TYPES || (ACTION_TYPES = {}));
export default function careOrderBabyFormReducer(state = initialType, action) {
    switch (action.type) {
        case ACTION_TYPES.CARE_ORDER_BABY_FORM_INIT: {
            return { ...state, ...action.payload };
        }
        case ACTION_TYPES.CARE_ORDER_BABY_FORM_UPDATE: {
            return { ...state, ...action.payload };
        }
        case ACTION_TYPES.CARE_ORDER_BABY_FORM_UPDATE_ALL_DAY_TIME_SLOT: {
            const currentTimeSlotList = state.timeSlotList;
            const currentAllDayTimeSlot = currentTimeSlotList[0];
            const { expectedStartTime, expectedServiceDays } = action.payload;
            const updatedTimeSlot = {
                expectedStartTime: expectedStartTime || get(currentAllDayTimeSlot, 'expectedStartTime'),
                expectedServiceDays: expectedServiceDays || get(currentAllDayTimeSlot, 'expectedServiceDays'),
            };
            return {
                ...state,
                timeSlotList: [updatedTimeSlot],
            };
        }
        case ACTION_TYPES.CARE_ORDER_BABY_FORM_APPLY_NEW_PART_TIME_EXPECTED_SERVICE_HOURS: {
            const currentTimeSlotList = state.timeSlotList;
            if (currentTimeSlotList.length === 0)
                return state;
            const { expectedServiceHours } = action.payload;
            const newTimeSlotList = currentTimeSlotList.map((timeSlot) => ({
                ...timeSlot,
                expectedServiceHours,
            }));
            return {
                ...state,
                timeSlotList: newTimeSlotList,
            };
        }
        case ACTION_TYPES.CARE_ORDER_BABY_FORM_APPLY_NEW_PART_TIME_EXPECTED_START_TIME: {
            const currentTimeSlotList = state.timeSlotList;
            if (currentTimeSlotList.length === 0)
                return state;
            const { ESTBufferHours, ESTFurthestDays, partTimeExpectedStartTime, partTimeExpectedServiceHours, } = action.payload;
            const hour = dayjs(partTimeExpectedStartTime).hour();
            const minute = dayjs(partTimeExpectedStartTime).minute();
            const newTimeSlotList = currentTimeSlotList.map((timeSlot) => {
                const newExpectedStartTime = dayjs(timeSlot.expectedStartTime)
                    .hour(hour)
                    .minute(minute)
                    .toISOString();
                const newTimeSlot = {
                    ...timeSlot,
                    expectedStartTime: newExpectedStartTime,
                };
                return newTimeSlot;
            });
            const newPartTimeTimeSlotOptions = getPartTimeTimeSlotOptionList({
                ESTBufferHours,
                ESTFurthestDays,
                partTimeExpectedStartTime,
                partTimeExpectedServiceHours,
            });
            const validTimeSlotList = newTimeSlotList.filter((timeSlot) => {
                const isValid = newPartTimeTimeSlotOptions.some((option) => option.expectedStartTime === timeSlot.expectedStartTime);
                return isValid;
            });
            return {
                ...state,
                timeSlotList: validTimeSlotList,
            };
        }
        case ACTION_TYPES.CARE_ORDER_BABY_FORM_UPDATE_PART_TIME_TIME_SLOT_LIST: {
            const currentTimeSlotList = state.timeSlotList;
            const { expectedStartTime } = action.payload;
            const isAlreadySelected = currentTimeSlotList.some((timeSlot) => timeSlot.expectedStartTime === expectedStartTime);
            const newTimeSlot = {
                expectedStartTime,
                expectedServiceHours: state.partTimeExpectedServiceHours,
            };
            const newTimeSlotList = isAlreadySelected
                ? currentTimeSlotList.filter((timeSlot) => timeSlot.expectedStartTime !== expectedStartTime)
                : [...currentTimeSlotList, newTimeSlot];
            const sortedNewTimeSlotList = orderBy(newTimeSlotList, ['expectedStartTime'], ['asc']);
            return {
                ...state,
                timeSlotList: sortedNewTimeSlotList,
            };
        }
        case ACTION_TYPES.CARE_ORDER_BABY_FORM_RESET_TIME_SELECTION_DATA: {
            return {
                ...state,
                timeSlotList: [],
                isAsap: null,
                initialType: CARE_ORDER_BABY_TYPE.ALL_DAY,
                careOrderPlanKey: CARE_ORDER_PLAN_KEY.ALL_DAY,
            };
        }
        default:
            return state;
    }
}
// actions
export const careOrderBabyFormUpdate = (payload) => ({
    type: ACTION_TYPES.CARE_ORDER_BABY_FORM_UPDATE,
    payload,
});
export const careOrderBabyFormUpdateAllDayTimeSlot = (payload) => ({
    type: ACTION_TYPES.CARE_ORDER_BABY_FORM_UPDATE_ALL_DAY_TIME_SLOT,
    payload,
});
export const careOrderBabyFormApplyNewPartTimeExpectedServiceHours = (payload) => ({
    type: ACTION_TYPES.CARE_ORDER_BABY_FORM_APPLY_NEW_PART_TIME_EXPECTED_SERVICE_HOURS,
    payload,
});
export const careOrderBabyFormApplyNewPartTimeExpectedStartTime = (payload) => ({
    type: ACTION_TYPES.CARE_ORDER_BABY_FORM_APPLY_NEW_PART_TIME_EXPECTED_START_TIME,
    payload,
});
export const careOrderBabyFormUpdatePartTimeTimeSlotList = (payload) => ({
    type: ACTION_TYPES.CARE_ORDER_BABY_FORM_UPDATE_PART_TIME_TIME_SLOT_LIST,
    payload,
});
export const careOrderBabyFormResetTimeSelectionData = () => ({
    type: ACTION_TYPES.CARE_ORDER_BABY_FORM_RESET_TIME_SELECTION_DATA,
});
// selectors
export const selectCareOrderBabyForm = createSelector((state) => state.careOrderBabyForm, (careOrderBabyForm) => careOrderBabyForm);
